
























import { Component, Mixins } from 'vue-property-decorator';
import { Popup, Toast } from 'vant';
import Dialog from '@/mixins/Dialog';
import SendVerifyCode from './SendVerifyCode.vue';
import Box from '@/components/Box.vue';

@Component({
    components: {
        'van-popup': Popup,
        'send-verify-code': SendVerifyCode,
        'box': Box
    }
})
export default class GetVCodeDialog extends Mixins(Dialog) {

    //手机号码
    public mobile: string = '';

    //验证码
    public code: string = '';
    
    //关闭弹窗
    public closeDialog(): void {
        this.$emit("close");
        this.show = false;
    }
    
    //提交
    public submit(): void {
        if (this.mobile == '') {
            Toast.fail("请输入手机号码");
        } else if (this.mobile.length < 11) {
            Toast.fail("请输入正确的手机号码");
        } else if (this.code == '') {
            Toast.fail("请输入验证码");
        } else {
            this.axios.post(this.$api.ADD_GAME, {
                mobile: this.mobile,
                code: this.code,
                enableEncrypt: true
            }).then((res: any) => {
                if (res.code == 1) {
                    this.$emit("success", res.data.money);
                    this.close();
                } else {
                    Toast.fail(res.message);
                }
            });
        }
    }
}
